/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useState, useEffect } from "react";

import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import { Button } from "@mui/material";
import UKToast from "@/common-components-src/components/UKToast/index";

import Styles from "../payButton/btn.module.scss";
declare global {
  let Klarna: any;
  // let window: any;
}

interface KlarnaProps {
  onSubmit: () => any; // 获取支付信息
  onFinish: (res: any) => void; // 支付完成后的回调
  onLoadingResult: (data: any, errorCb: () => void) => any; // 支付loading
}

const KlarnaPay: FC<KlarnaProps> = observer((props) => {
  const { t } = useTranslation();
  const { checkoutStore } = useStores();
  const [loading, setLoading] = useState(false);

  // 关闭loading
  const closeLoading = () => {
    setLoading(false);
    checkoutStore.setSafetyLoading(false);
  };

  // 关闭loading
  const onPayError = () => {
    UKToast.show({
      content: t("common.message.networkError"), // 弹窗内容
      icon: "error", // 可选：success, fail, loading, warn, info，影响图标
    });
    closeLoading();
    // setError(true);
  };

  /**
   *
   * 提单，并唤起支付
   *
   */
  const handleSubmit = async () => {
    setLoading(true);
    checkoutStore.setSafetyLoading(true);
    // 提单接口在父组件中统一处理
    const res: any = await props.onSubmit();
    // 如果提单成功，则唤起支付
    try {
      const payload = JSON.parse(res.data.payload);
      // 初始化klarna支付
      klarnaAsyncCallback(payload);
    } catch (error) {
      onPayError();
    }

    closeLoading();
  };

  // 初始化Klarna支付 && 页面加载Klarna支付
  const klarnaAsyncCallback = (initData: any) => {
    try {
      Klarna.Payments.init({ ...initData });
    } catch (error) {
      onPayError();
      console.log(error, "Klarna init error");
    }

    Klarna.Payments.load(
      {
        container: "#klarna-payments-container",
      },
      function (res: any) {
        console.log(res, "Klarna load response");
        // 唤起支付弹窗/页面
        if (res.show_form) {
          authorizeMe(initData);
          return;
        }
        onPayError();
      },
    );
  };

  // 唤起支付页面
  const authorizeMe = (initData: any) => {
    console.log("authorize call triggered");
    Klarna.Payments.authorize(
      {
        auto_finalize: "true",
        container: "#klarna-payments-container",
      },
      {},
      function (res: any) {
        res.session_id = initData.session_id;
        // 支付成功
        if (res.show_form && res.approved && res.authorization_token) {
          redirectResult(res);
          return;
        }
        // 支付失败
        if (res.error_code) {
          onPayError();
          return;
        }
        // 支付取消
        closeLoading();
      },
    );
  };

  // 后端redirect接口
  const redirectResult = async (params: any) => {
    const requestData = {
      txnSeqno: (checkoutStore.payResult as any).id,
      txnScene: "Consumption",
      payMethod: Number(checkoutStore.payMethod),
      urlParams: {
        payDataExt: JSON.stringify(params),
      },
    };
    props.onLoadingResult(requestData, onPayError);
  };

  // 加载Klarna sdk
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://x.klarnacdn.net/kp/lib/v1/api.js";
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      {/* 提单按钮 */}
      <Button variant="contained" fullWidth className={Styles.commonBtn} disabled={loading || checkoutStore.submitOrderBtnDisabled} onClick={handleSubmit}>
        {t("checkout.common.continue")}
      </Button>
      {/* 放置klarna支付内容 */}
      <div id="klarna-payments-container" style={{ display: "none" }}></div>
    </>
  );
});

export default KlarnaPay;
